import React from "react";
import Separator from "../Separator";
import Typography from "../Typography";

type PreviousSelectionSectionProps = {
    sectionTitle: string;
    children: React.ReactNode;
};

const PreviousSelectionSection = ({
    sectionTitle,
    children,
}: PreviousSelectionSectionProps) => {
    return (
        <>
            <Typography
                variant="title-medium"
                component="h2"
                className="mt-4 mb-1"
            >
                {sectionTitle}
            </Typography>
            <Separator className="mb-2" />
            <div className="grid grid-cols-3 gap-5 break-words">{children}</div>
        </>
    );
};

export default PreviousSelectionSection;
